import { Badge, Tab, TabList, makeStyles, tokens } from "@fluentui/react-components";
import { Attach16Regular, Comment16Regular, History16Regular, Note16Regular } from "@fluentui/react-icons";
import { formatCountBadge } from "@/lib/format";

/** Shared building blocks for detail drawers (Task, 이슈·결정). */

const useStyles = makeStyles({
  tabs: {
    marginTop: tokens.spacingVerticalXXS,
  },
  badge: {
    marginLeft: "4px",
  },
});

export { DetailSection, type DetailSectionProps } from "@/components/detail-section";

export type DetailTab = "details" | "comments" | "attachments" | "activity";

export function DetailTabs({
  value,
  onChange,
  counts,
  ariaLabel,
}: {
  value: DetailTab;
  onChange: (tab: DetailTab) => void;
  counts: { comments: number; attachments: number; activity: number };
  ariaLabel: string;
}) {
  const styles = useStyles();
  const count = (n: number, informative?: boolean) =>
    n > 0 ? (
      <Badge size="small" appearance="tint" color={informative ? "informative" : undefined} className={styles.badge}>
        {formatCountBadge(n)}
      </Badge>
    ) : null;
  return (
    <div className={styles.tabs}>
      <TabList size="small" selectedValue={value} onTabSelect={(_, d) => onChange(d.value as DetailTab)} aria-label={ariaLabel}>
        <Tab value="details" icon={<Note16Regular />}>
          상세
        </Tab>
        <Tab value="comments" icon={<Comment16Regular />}>
          <span>댓글</span>
          {count(counts.comments, true)}
        </Tab>
        <Tab value="attachments" icon={<Attach16Regular />}>
          <span>파일</span>
          {count(counts.attachments)}
        </Tab>
        <Tab value="activity" icon={<History16Regular />}>
          <span>활동</span>
          {count(counts.activity)}
        </Tab>
      </TabList>
    </div>
  );
}
